import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M8 15V5.5A2.5 2.5 0 0 0 5.5 3M16 15V5.5A2.5 2.5 0 0 0 13.5 3M8 7.5h8m-8 4h8M2 19c1.25 1.333 3.75 1.333 5 0s3.75-1.333 5 0 3.75 1.333 5 0 3.75-1.333 5 0"
    }, null, -1)
  ])))
}
export default { render: render }